<app-header></app-header>

<section class="bredcrumb">
  <div class="container">
      <ul class="brd-nav">
          <li> <a [routerLink]="['/']"> Home </a></li>
          <li> <span> Orders </span></li>
      </ul>
  </div>
</section>
<!--- End of bredcrumb --->

<section class="single-page order-list padd-row">
  <div class="container">
      <div class="row">
          <div class="col-lg-4">
              <div class="order-list-sidebar grey-bg">
                  <h3> Orders </h3>
                  <ul >
                      <li> <a (click)="changeTab('doctors');"  routeeLink="null"  [ngClass]="activeTab=='doctors'  ? 'active'  : ''"> Doctors </a></li>
                      <li> <a (click)="changeTab('pharmacy');"  routeeLink="null" [ngClass]="activeTab=='pharmacy'  ? 'active' : ''"> Pharmacy </a></li>
                      <li> <a (click)="changeTab('labs');"  routeeLink="null" [ngClass]="activeTab=='labs' ?  'active' : ''"> Labs </a></li>
                      <li> <a (click)="changeTab('hospitals');"  routeeLink="null" [ngClass]="activeTab=='hospitals'  ? 'active' : ''"> Hospitals </a></li>
                      <li> <a (click)="changeTab('ambulances');"  routeeLink="null" [ngClass]="activeTab=='ambulances'  ? 'active' : ''"> Ambulance </a></li>

                  </ul>
              </div>
          </div>

          <div *ngIf="activeTab=='doctors'" class=" col-lg-8" id="doctors">

                <div class="filter-date-pharmacy">
                        <div class="filter-date-pharmacy-start-date">
             <!-- <span>Select Date</span>  -->
                <div class="style-datepicker"  >
                <input  placeholder="Select  Date..." class="form-control" style="width: 135px;margin-left: 50px"
                [bsConfig]="{ dateInputFormat: 'DD, MMMM YYYY', showWeekNumbers:false }" #dp="bsDatepicker" bsDatepicker readonly
                [(ngModel)]="bookingDate" [(bsValue)]="bookingDate"   (ngModelChange)="dateChangeStart()">
                </div>
                <div class="style-datepicker"  >

                    </div>
            </div>

                        <button class="btn-style"  style="margin-left: 50px"(click)="getUserHistory()">FilterSS</button>
                        <button class="btn-style-grey btn" (click)="resetFilter()">Reset Filter</button>
                    </div>
              <div class="pharmacy-order-list-main-rightside doctors-order-list-main-rightside">
                  <!-- <h3> Upcoming </h3> -->
                  <div class="pharmacy-order-list-upcoming">
                      <div *ngFor="let doctorBooking of doctorBookingData" class="pharmacy-order-list-upcoming-row">
                          <div class="row">
                              <div class="col-md-7">
                                  <div class="doctors-order-list-box-lft">
                                      <div class="doctors-order-list--lft-date">
                                          <h5> {{ doctorBooking?.month   }} {{ doctorBooking?.year }} <span> {{ doctorBooking.date  }} </span>  {{ doctorBooking.bookingDay }} </h5>

                                      </div>
                                      <div class="doctors-order-list--lft-img">
                                          <img [src]="doctorBooking?.doctorId?.profilePicture" alt="image" *ngIf="!!doctorBooking?.doctorId">
                                      </div>
                                      <div class="doctors-order-list-box-lft-cnt">
                                          <h4 *ngIf="!!doctorBooking?.doctorId"> 
                                                <a [routerLink]="['/doctors/detail/'+doctorBooking?.doctorId?.uniquekey]"> 
                                                    {{ doctorBooking?.doctorId?.name }} 
                                                </a> 
                                            <span> 
                                                {{ doctorBooking?.doctorId?.speciality?.join(',') }} | {{ doctorBooking?.doctorId?.education?.join(',') }} </span> 
                                        </h4>
                                          {{ doctorBooking?.doctorId?.phoneNo }}
                                          <p *ngIf="doctorBooking?.status=='COMPLETE'">  YOUR APPOINTMENT IS COMPLETED SUCCESSFULLY..PLEASE ADD A REVIEW </p>
                                          <p *ngIf=" doctorBooking?.status=='PENDING' && doctorBooking?.doctorId"> YOUR APPOINTMENT IS WAITING FOR APPROVAL </p>
                                          <p *ngIf=" doctorBooking?.status=='APPROVE'"> YOUR APPOINTMENT IS CONFIRMED </p>
                                          <p *ngIf=" doctorBooking?.status=='CANCEL'"> YOUR APPOINTMENT IS CANCELLED </p>
                                          <p *ngIf="!doctorBooking?.doctorId"> WE ARE WORKING ON APPOINTMENT </p>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-md-5">
                                  <div class="doctors-order-list-box-rght">
                                       <h4 [innerHTML]="convertTime(doctorBooking.startTime)" *ngIf="!!doctorBooking?.doctorId"> </h4>
                                      <!--  <p> Booking ID : 021556 </p> -->
                                      <div class="doctors-order-list-btns" *ngIf="!!doctorBooking?.doctorId">
                                          <a [routerLink]="['/chat/'+doctorBooking?.doctorId?._id]" class="btn-style btn-style-border"> Chat </a>
                                          <!-- <a href="doctors-chat.html" class="btn-style"> Cancel </a> -->
                                      </div>
                                      <div *ngIf="doctorBooking.status=='COMPLETE' && !doctorBooking?.hospitalId" (click)="openReviewPopup('doctor',doctorBooking?.doctorId?._id,doctorBooking?._id)">Add a Review</div>
                                      <!-- <div *ngIf="doctorBooking.status=='COMPLETE' && doctorBooking?.hospitalId" (click)="openReviewPopup('hospital',doctorBooking?.hospitalId,doctorBooking?._id)">Add a Review</div> -->
                                      <i [hidden]="doctorBooking.status!='RATED'" class="fa fa-star"   *ngFor='let in of counter( parseInt(doctorBooking?.stars)) ;let i = index'  aria-hidden="true"></i>
                                      <i [hidden]="doctorBooking.status!='RATED'" class="fa fa-star-o"   *ngFor='let in of counter(5- parseInt(doctorBooking?.stars)) ;let i = index'  aria-hidden="true"></i>
                                  </div>
                              </div>
                          </div>
                      </div>

                  </div>
                  <!-- <div class="border-top-solid"></div>
                  <h3> Past </h3>
                  <div class="pharmacy-order-list-upcoming">
                      <div class="pharmacy-order-list-upcoming-row">
                          <div class="row">
                              <div class="col-md-7">
                                  <div class="doctors-order-list-box-lft">
                                      <div class="doctors-order-list--lft-date">
                                          <h5> Aug 2019 <span> 30 </span> Friday </h5>
                                      </div>
                                      <div class="doctors-order-list--lft-img">
                                          <img src="assets/images/doc-img-2.jpg" alt="image">
                                      </div>
                                      <div class="doctors-order-list-box-lft-cnt">
                                          <h4> Dr. Methew Hidden <span> Dentist | MBBS,MD </span> </h4>
                                          <p> Booking ID : 021556 </p>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-md-5">
                                  <div class="doctors-order-list-box-rght">
                                      <h4> 10 : 30 am </h4>
                                      <div class="doctors-order-list-btns">
                                          <a href="doctors-chat.html" class="btn-style"> Write a Review </a>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>

                  </div>  -->
              </div>
          </div>
          <div *ngIf="activeTab=='pharmacy'" class=" col-lg-8" id="pharmacy">
                <div class="filter-date-pharmacy">
                        <div class="filter-date-pharmacy-start-date">
             <!-- <span>Select Date</span>  -->
                <div class="style-datepicker"  >
                <input  placeholder="Select  Date..." class="form-control" style="width: 135px;"
                [bsConfig]="{ dateInputFormat: 'DD, MMMM YYYY', showWeekNumbers:false }" #dp="bsDatepicker" bsDatepicker readonly
                [(ngModel)]="bookingDate" [(bsValue)]="bookingDate"   (ngModelChange)="dateChangeStart()">
                </div>
                <!-- <div class="style-datepicker"  >
                    {{ doctorBooking?.doctorId?.phoneNo }}
                    </div> -->
            </div>

                        <button class="btn-style" (click)="getUserHistory()">Filter</button>
                        <button class="btn-style-grey btn" (click)="resetFilter()">Reset Filter</button>
                    </div>
            <div class="pharmacy-order-list-main-rightside doctors-order-list-main-rightside">
                <!-- <h3> Upcoming </h3> -->
                <div class="pharmacy-order-list-upcoming">
                    <div *ngFor="let pharmacyBooking of pharmacyBookingData" class="pharmacy-order-list-upcoming-row">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="doctors-order-list-box-lft">
                                    <div class="doctors-order-list--lft-date">
                                        <h5> {{ pharmacyBooking?.createdAt | date:'MMM	yyyy'  }} <span> {{ pharmacyBooking?.createdAt | date: 'dd' }} </span> {{ pharmacyBooking.createdAt | date:'EEEE' }} </h5>
                                    </div>
                                    <!-- <p> Booking ID : 021556 </p><p> Booking ID : 021556 </p> -->
                                    <!-- <div class="doctors-order-list--lft-img">
                                        <img [src]="doctorBooking?.doctorId?.profilePicture" alt="image">
                                    </div> -->
                                    <div class="doctors-order-list-box-lft-cnt">
                                        <h4><a [routerLink]="['/pharmacy/detail/'+pharmacyBooking?.pharmecyId?._id]">  {{ pharmacyBooking?.pharmecyId?.name  }}</a> <span>  </span> </h4>
                                        {{ pharmacyBooking?.pharmecyId?.phoneNo }}
                                        <p *ngIf="pharmacyBooking?.status=='COMPLETE'">  YOUR ORDER IS COMPLETED SUCCESSFULLY..PLEASE ADD A REVIEW </p>
                                        <p *ngIf=" pharmacyBooking?.status=='PENDING'"> YOUR ORDER IS WAITING FOR APPROVAL </p>
                                        <p *ngIf=" pharmacyBooking?.status=='APPROVE'"> YOUR ORDER IS CONFIRMED </p>
                                        <p *ngIf=" pharmacyBooking?.status=='CANCEL'"> YOUR ORDER IS CANCELLED </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="doctors-order-list-box-rght">
                                     <h4 >{{ pharmacyBooking.createdAt | date:'h:mm a'  }} </h4>
                                     <h5 (click)="showPharmacyBooking(pharmacyBooking)" [hidden]="pharmacyBooking.status=='CANCEL'" style="color: #26abe3 !important;cursor:pointer" > Order Details </h5>
                                     <div style="color: #26abe3 !important;cursor:pointer"   *ngIf="pharmacyBooking.status=='COMPLETE'" (click)="openReviewPopup('pharmacy',pharmacyBooking?.pharmecyId?._id,pharmacyBooking?._id)">Add a Review</div>
                                     <i [hidden]="pharmacyBooking.status!='RATED'" class="fa fa-star"   *ngFor='let in of counter( parseInt(pharmacyBooking?.stars)) ;let i = index'  aria-hidden="true"></i>
                                     <i [hidden]="pharmacyBooking.status!='RATED'" class="fa fa-star-o"   *ngFor='let in of counter(5- parseInt(pharmacyBooking?.stars)) ;let i = index'  aria-hidden="true"></i>
                                    <!-- <div class="doctors-order-list-btns">
                                        <a href="doctors-chat.html" class="btn-style btn-style-border"> Chat </a>
                                        <a href="doctors-chat.html" class="btn-style"> Cancel </a>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- <div class="border-top-solid"></div>
                <h3> Past </h3>
                <div class="pharmacy-order-list-upcoming">
                    <div class="pharmacy-order-list-upcoming-row">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="doctors-order-list-box-lft">
                                    <div class="doctors-order-list--lft-date">
                                        <h5> Aug 2019 <span> 30 </span> Friday </h5>
                                    </div>
                                    <div class="doctors-order-list--lft-img">
                                        <img src="assets/images/doc-img-2.jpg" alt="image">
                                    </div>
                                    <div class="doctors-order-list-box-lft-cnt">
                                        <h4> Dr. Methew Hidden <span> Dentist | MBBS,MD </span> </h4>
                                        <p> Booking ID : 021556 </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="doctors-order-list-box-rght">
                                    <h4> 10 : 30 am </h4>
                                    <div class="doctors-order-list-btns">
                                        <a href="doctors-chat.html" class="btn-style"> Write a Review </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>  -->
            </div>
        </div>
        <div *ngIf="activeTab=='labs'" class=" col-lg-8" id="labs">
                <div class="filter-date-pharmacy">
                        <div class="filter-date-pharmacy-start-date">
             <!-- <span>Select Date</span>  -->
                <div class="style-datepicker"  >
                <input  placeholder="Select  Date..." class="form-control" style="width: 135px;"
                [bsConfig]="{ dateInputFormat: 'DD, MMMM YYYY', showWeekNumbers:false }" #dp="bsDatepicker" bsDatepicker readonly
                [(ngModel)]="bookingDate" [(bsValue)]="bookingDate"   (ngModelChange)="dateChangeStart()">
                </div>
                <div class="style-datepicker"  >

                    </div>
            </div>

                        <button class="btn-style" (click)="getUserHistory()">Filter</button>
                        <button class="btn-style-grey btn" (click)="resetFilter()">Reset Filter</button>
                    </div>
            <div class="pharmacy-order-list-main-rightside doctors-order-list-main-rightside">
                <!-- <h3> Upcoming </h3> -->
                <div class="pharmacy-order-list-upcoming">
                    <div *ngFor="let labBooking of labBookingData" class="pharmacy-order-list-upcoming-row">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="doctors-order-list-box-lft">
                                    <div class="doctors-order-list--lft-date">
                                            <h5> {{ labBooking.dateTime | date:'MMM	yyyy'  }} <span> {{ labBooking.dateTime | date: 'dd' }} </span> {{ labBooking.createdAt | date:'EEEE' }} </h5>

                                    </div>

                                    <!-- <div class="doctors-order-list--lft-img">
                                        <img [src]="doctorBooking?.doctorId?.profilePicture" alt="image">
                                    </div> -->
                                    <div class="doctors-order-list-box-lft-cnt">
                                        <h4> <a [routerLink]="['/labs/detail/'+labBooking?.labId?._id]"> {{ labBooking?.labId?.name }}</a> <span>  {{ labBooking?.tests }}  </span> </h4>
                                        {{ labBooking?.labId?.phoneNo }}
                                        <p *ngIf="labBooking?.status=='COMPLETE'">  YOUR ORDER IS COMPLETED SUCCESSFULLY..PLEASE ADD A REVIEW </p>
                                        <p *ngIf=" labBooking?.status=='PENDING'"> YOUR ORDER IS WAITING FOR APPROVAL </p>
                                        <p *ngIf=" labBooking?.status=='APPROVE'"> YOUR ORDER IS CONFIRMED </p>
                                        <p *ngIf=" labBooking?.status=='CANCEL'"> YOUR ORDER IS CANCELLED </p>

                                        <p> Total Price : Rs {{ labBooking.totalPrice }}/- </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="doctors-order-list-box-rght">
                                     <h4> {{ labBooking.dateTime | date:'h:mm a'  }}</h4>
                                     <h5 style="color: #26abe3 !important;cursor:pointer" [hidden]="labBooking.status=='CANCEL'"   (click)="showLabBooking(labBooking)"> Order Details </h5>
                                     <div style="color: #26abe3 !important;cursor:pointer"   *ngIf="labBooking.status=='COMPLETE'" (click)="openReviewPopup('lab',labBooking?.labId?._id,labBooking?._id)">Add a Review</div>
                                     <i [hidden]="labBooking.status!='RATED'" class="fa fa-star"   *ngFor='let in of counter( parseInt(labBooking?.stars)) ;let i = index'  aria-hidden="true"></i>
                                     <i [hidden]="labBooking.status!='RATED'" class="fa fa-star-o"   *ngFor='let in of counter(5- parseInt(labBooking?.stars)) ;let i = index'  aria-hidden="true"></i>
                                    <!--  <p> Booking ID : 021556 </p> -->
                                    <!-- <div class="doctors-order-list-btns">
                                        <a href="doctors-chat.htmlngIf" class="btn-style btn-style-border"> Chat </a>
                                        <a href="doctors-chat.html" class="btn-style"> Cancel </a>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- <div class="border-top-solid"></div>
                <h3> Past </h3>
                <div class="pharmacy-order-list-upcoming">
                    <div class="pharmacy-order-list-upcoming-row">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="doctors-order-list-box-lft">
                                    <div class="doctors-order-list--lft-date">
                                        <h5> Aug 2019 <span> 30 </span> Friday </h5>
                                    </div>
                                    <div class="doctors-order-list--lft-img">
                                        <img src="assets/images/doc-img-2.jpg" alt="image">
                                    </div>
                                    <div class="doctors-order-list-box-lft-cnt">
                                        <h4> Dr. Methew Hidden <span> Dentist | MBBS,MD </span> </h4>
                                        <p> Booking ID : 021556 </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="doctors-order-list-box-rght">
                                    <h4> 10 : 30 am </h4>
                                    <div class="doctors-order-list-btns">
                                        <a href="doctors-chat.html" class="btn-style"> Write a Review </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>  -->
            </div>
        </div>
        <div *ngIf="activeTab=='hospitals'" class=" col-lg-8" id="hospitals">
                <div class="filter-date-pharmacy">
                        <div class="filter-date-pharmacy-start-date">
             <!-- <span>Select Date</span>  -->
                <div class="style-datepicker"  >
                <input  placeholder="Select  Date..." class="form-control" style="width: 135px;"
                [bsConfig]="{ dateInputFormat: 'DD, MMMM YYYY', showWeekNumbers:false }" #dp="bsDatepicker" bsDatepicker readonly
                [(ngModel)]="bookingDate" [(bsValue)]="bookingDate"   (ngModelChange)="dateChangeStart()">
                </div>
                <div class="style-datepicker"  >

                    </div>
            </div>

                        <button class="btn-style" (click)="getUserHistory()">Filter</button>
                        <button class="btn-style-grey btn" (click)="resetFilter()">Reset Filter</button>
                    </div>
            <div class="pharmacy-order-list-main-rightside doctors-order-list-main-rightside">
                <!-- <h3> Upcoming </h3> -->
                <div class="pharmacy-order-list-upcoming">
                    <div *ngFor="let hospitalBooking of hospitalBookingData" class="pharmacy-order-list-upcoming-row">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="doctors-order-list-box-lft">
                                    <div class="doctors-order-list--lft-date">
                                         <h5> {{ hospitalBooking?.month   }} {{ hospitalBooking?.year }} <span> {{ hospitalBooking?.date  }} </span> {{ hospitalBooking?.bookingDay }} </h5>
                                    </div>
                                    <!-- <p> Booking ID : 021556 </p><p> Booking ID : 021556 </p> -->
                                    <div class="doctors-order-list--lft-img">
                                        <img [src]="hospitalBooking?.hospitalId?.coverPhoto" alt="image">
                                    </div>
                                    <div class="doctors-order-list-box-lft-cnt">
                                        <h4> <a [routerLink]="['/hospitals/detail/'+hospitalBooking?.hospitalId?._id]"> {{ hospitalBooking?.hospitalId?.name }} </a> <span> Booking Appointment </span> </h4>
                                        <!-- <p> Booking ID : 021556 </p> -->
                                        {{ hospitalBooking?.hospitalId?.phoneNo }}
                                        <p *ngIf="hospitalBooking?.status=='COMPLETE'">  YOUR APPOINTMENT IS COMPLETED SUCCESSFULLY..PLEASE ADD A REVIEW </p>
                                        <p *ngIf=" hospitalBooking?.status=='PENDING'"> YOUR APPOINTMENT IS WAITING FOR APPROVAL </p>
                                        <p *ngIf=" hospitalBooking?.status=='APPROVE'"> YOUR APPOINTMENT IS CONFIRMED </p>
                                        <p *ngIf=" hospitalBooking?.status=='CANCEL'"> YOUR APPOINTMENT IS CANCELLED </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="doctors-order-list-box-rght">
                                     <h4 [innerHTML]="convertTime(hospitalBooking.time)"> </h4>
                                    <!--  <p> Booking ID : 021556 </p> -->
                                    <!-- <divsr class="doctors-order-list-btns">
                                        <a [routerLink]="['/chat/'+hospitalBooking?.hospitalId?._id]" class="btn-style btn-style-border"> Chat </a>
                                         <a href="doctors-chat.html" class="btn-style"> Cancel </a>
                                    </div> -->
                                    <div *ngIf="hospitalBooking.status=='COMPLETE'" (click)="openReviewPopup('hospital',hospitalBooking?.hospitalId?._id,hospitalBooking?._id)">Add a Review</div>
                                    <!-- <div *ngIf="doctorBooking.status=='COMPLETE' && doctorBooking?.hospitalId" (click)="openReviewPopup('hospital',doctorBooking?.hospitalId,doctorBooking?._id)">Add a Review</div> -->
                                    <i [hidden]="hospitalBooking.status!='RATED'" class="fa fa-star"   *ngFor='let in of counter( parseInt(hospitalBooking?.stars)) ;let i = index'  aria-hidden="true"></i>
                                    <i [hidden]="hospitalBooking.status!='RATED'" class="fa fa-star-o"   *ngFor='let in of counter(5- parseInt(hospitalBooking?.stars)) ;let i = index'  aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- <div class="border-top-solid"></div>
                <h3> Past </h3>
                <div class="pharmacy-order-list-upcoming">
                    <div class="pharmacy-order-list-upcoming-row">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="doctors-order-list-box-lft">
                                    <div class="doctors-order-list--lft-date">
                                        <h5> Aug 2019 <span> 30 </span> Friday </h5>
                                    </div>
                                    <div class="doctors-order-list--lft-img">
                                        <img src="assets/images/doc-img-2.jpg" alt="image">
                                    </div>
                                    <div class="doctors-order-list-box-lft-cnt">
                                        <h4> Dr. Methew Hidden <span> Dentist | MBBS,MD </span> </h4>
                                        <p> Booking ID : 021556 </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="doctors-order-list-box-rght">
                                    <h4> 10 : 30 am </h4>
                                    <div class="doctors-order-list-btns">
                                        <a href="doctors-chat.html" class="btn-style"> Write a Review </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>  -->
            </div>
        </div>
        <div *ngIf="activeTab=='ambulances'" class=" col-lg-8" id="ambulances">
                <div class="filter-date-pharmacy">
                        <div class="filter-date-pharmacy-start-date">
             <!-- <span>Select Date</span>  -->
                <div class="style-datepicker"  >
                <input  placeholder="Select  Date..." class="form-control" style="width: 135px;"
                [bsConfig]="{ dateInputFormat: 'DD, MMMM YYYY', showWeekNumbers:false }" #dp="bsDatepicker" bsDatepicker readonly
                [(ngModel)]="bookingDate" [(bsValue)]="bookingDate"   (ngModelChange)="dateChangeStart()">
                </div>
                <div class="style-datepicker"  >

                    </div>
            </div>

                        <button class="btn-style" (click)="getUserHistory()">Filter</button>
                        <button class="btn-style-grey btn" (click)="resetFilter()">Reset Filter</button>
                    </div>
          <div class="pharmacy-order-list-main-rightside doctors-order-list-main-rightside">
              <!-- <h3> Upcoming </h3> -->
              <div class="pharmacy-order-list-upcoming">
                  <div *ngFor="let ambulanceBooking of ambulanceBookingData" class="pharmacy-order-list-upcoming-row">
                      <div class="row">
                          <div class="col-md-7">
                              <div class="doctors-order-list-box-lft">
                                  <div class="doctors-order-list--lft-date">
                                      <h5> {{ ambulanceBooking.createdAt | date:'MMM	yyyy'  }} <span> {{ ambulanceBooking.createdAt | date: 'dd' }} </span> {{ ambulanceBooking.bookingDay }} </h5>
                                  </div>

                                  <div class="doctors-order-list-box-lft-cnt">
                                        <h4>  {{ ambulanceBooking?.ambulanceId?.fullName }}  </h4>
                                        {{ ambulanceBooking?.ambulanceId?.phoneNo }}<br>
                                        {{ ambulanceBooking?.address }}

                                      <p *ngIf="ambulanceBooking?.status=='COMPLETE'">  YOUR BOOKING WAS COMPLETED  </p>
                                      <p *ngIf=" ambulanceBooking?.status=='ASSIGN_DRIVER'"> YOUR BOOKING IS WAITING FOR APPROVAL </p>
                                      <p *ngIf=" ambulanceBooking?.status=='APPROVE'"> YOUR BOOKING IS CONFIRMED </p>
                                      <p *ngIf=" ambulanceBooking?.status=='CANCELED'"> YOUR BOOKING WAS CANCELLED </p>

                                  </div>
                              </div>
                          </div>
                          <div class="col-md-5">
                              <div class="doctors-order-list-box-rght">
                                   <h4 >{{ ambulanceBooking.createdAt | date:' h:mm a' }} </h4>

                              </div>
                          </div>
                      </div>
                  </div>

              </div>
              <!-- <div class="border-top-solid"></div>
              <h3> Past </h3>
              <div class="pharmacy-order-list-upcoming">
                  <div class="pharmacy-order-list-upcoming-row">
                      <div class="row">
                          <div class="col-md-7">
                              <div class="doctors-order-list-box-lft">
                                  <div class="doctors-order-list--lft-date">
                                      <h5> Aug 2019 <span> 30 </span> Friday </h5>
                                  </div>
                                  <div class="doctors-order-list--lft-img">
                                      <img src="assets/images/doc-img-2.jpg" alt="image">
                                  </div>
                                  <div class="doctors-order-list-box-lft-cnt">
                                      <h4> Dr. Methew Hidden <span> Dentist | MBBS,MD </span> </h4>
                                      <p> Booking ID : 021556 </p>
                                  </div>
                              </div>
                          </div>
                          <div class="col-md-5">
                              <div class="doctors-order-list-box-rght">
                                  <h4> 10 : 30 am </h4>
                                  <div class="doctors-order-list-btns">
                                      <a href="doctors-chat.html" class="btn-style"> Write a Review </a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

              </div>  -->
          </div>
      </div>
      </div>
  </div>
</section>
<!--- End of doctors-detail --->


<input type="hidden" data-toggle="modal"
data-target="#add-review-dashboard" id="add-review-dashboard_popup_trigger" >


 <!-- The Modal -->
 <div class="modal fade  review_popup" id="add-review-dashboard">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Modal body -->
            <div class="modal-body">
                <div class="sign-up-form add-doc-form">
                    <div class="add-doc-ambu-cmn add-treat-form">
                        <h2> What would you like to Add? </h2>
                        <form class="doctors-edit-main p-0 no-shadow">
                            <div class="doctors-edit-lft">
                                <div class="edit-profile-form-rows">
                                    <div class="row no-gutters">
                                       <div class="col-md-12">
                                        <div class="reviews-rating">
                                            <i  aria-hidden="true" (click)="ratingValue=1;ratingComment='Very poor'" [ngClass]="ratingValue>=1 ? 'fa fa-star' : 'fa fa-star fa-star-not-fill'"></i>
                                            <i  aria-hidden="true" (click)="ratingValue=2;ratingComment='Poor'" [ngClass]="ratingValue>=2 ? 'fa fa-star' : 'fa fa-star fa-star-not-fill'"> </i>
                                            <i  aria-hidden="true" (click)="ratingValue=3;ratingComment='Satisfactory'" [ngClass]="ratingValue>=3 ? 'fa fa-star' : 'fa fa-star fa-star-not-fill'"></i>
                                            <i  aria-hidden="true" (click)="ratingValue=4;ratingComment='Good'" [ngClass]="ratingValue>=4 ? 'fa fa-star' : 'fa fa-star fa-star-not-fill'"></i>
                                            <i  aria-hidden="true" (click)="ratingValue=5;ratingComment='Loved It!!'" [ngClass]="ratingValue>=5 ? 'fa fa-star' : 'fa fa-star fa-star-not-fill'"></i>
                                            <span > {{ ratingComment }} </span></div>
                                       </div>
                                        <div class="col-md-12">
                                            <label> Comment </label>
                                            <input type="text" name="treatmentDescription" class="form-control" name="treatmentDescription" [(ngModel)]="comment"  placeholder="Enter Comment">
                                        </div>

                                        <div class="col-md-12">
                                            <div class="add-doc-btns-btm mt-3">
                                                <!-- <button type="submit"    class="btn-style no-shadow"> Save </button>
                                                <button type="button"  class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </button> -->
                                                <a [routerLink]="null" (click)="addReview()" class="btn-style no-shadow"> Add </a>
                                                <a href="javascript://" class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>




 <input type="hidden"  data-toggle="modal" id="lab_order_details_trigger" data-target="#lab_order_details">

<div class="modal fade"  id="lab_order_details">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">


            <div class="modal-body">

                    <div class="row">

                            <div class="col-lg-12">
                                <div class="labs-order-left-side">
                                    <div class="row">
                                        <div *ngFor="let labTest of showLabTests" class="col-md-6">
                                            <div class="lab-ordr-list-box lab-details-test-box">
                                                <div class="lab-details-test-box-top-cnt">
                                                    <div class="d-flex">
                                                        <h5> {{ labTest?.name?.slice(0,10) }} {{ labTest?.name?.length>10 ? '...' : '' }} </h5>


                                                    </div>
                                                </div>
                                                <p> {{ labTest?.description?.slice(0,100) }}{{ labTest?.description?.length>100 ? '...' : '' }} </p>
                                                <div class="lab-details-test-box-btm-cnt">
                                                    <div class="d-flex">
                                                        <div class="lab-test-incre-decre text-left">

                                                            <span>Quantity: {{ labTest?.quantity }} </span>

                                                        </div>
                                                        <div class="price">Rs. {{ labTest?.price }}/-  </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="lab_report_heading" *ngIf="showLabReports.length>0"><h4>Lab Reports:</h4>
                                            <div *ngFor="let report of showLabReports">
                                                    <img style="cursor:pointer" (click)="showLabReportsSlider()" width="70px" height="70px" *ngIf="report.type=='image'"  [src]="report.image">
                                                   <a *ngIf="report.type=='pdf'" [href]="report.image" [download]="report.image"> <img style="cursor:pointer"  width="70px" height="70px"   [src]="'assets/images/pdf.jpeg'"></a>

                                                </div>

                                            </div>

                                    </div>
                                </div>

                            </div>

                            <div class="col-lg-12">
                                    <div *ngIf="bookingDescription!=''"><p>Description: {{ bookingDescription }}</p></div>
                                <div class="doc-detail-lft p-0 sidebar">

                                    <div class="doc-detail-box grey-bg p-25-side mb-4">
                                        <div class="labs-orders-side-box">
                                            <div class="labs-orders-side-box-head">
                                                <h4> Delivery Address </h4>
                                            </div>
                                            <div class="labs-orders-side-box-body">
                                                <ul>
                                                    <li>
                                                        <p> {{ addressFields.address }}, {{ addressFields.city }}  </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="doc-detail-box grey-bg p-25-side mb-4">




                                                <div class="labs-orders-side-box-body">
                                                    <ul>
                                                        <li>
                                                            <p> <strong> Total Amount </strong> </p>
                                                            <div class="order-price"> Rs. {{ totalAmount }}/- </div>
                                                        </li>
                                                    </ul>
                                                </div>



                                    </div>


                                </div>
                            </div>

                        </div>
                </div>
                </div>
                </div>
                </div>





                <input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade"  id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Order Detail</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
            <slideshow
            [minHeight]="'525px'"

            [imageUrls]="imageUrlArray"></slideshow>
        <button class="btn btn-primary" data-toggle="modal" data-target="#orderImagesModal">OK</button>

      </div>
    </div>
  </div>
</div>


<input type="hidden" id="orderImagesCLickLabs" data-toggle="modal" data-target="#orderImagesModalLabs">

<!-- The Modal -->
<div class="modal fade"  id="orderImagesModalLabs">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Lab Reports</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
            <slideshow
            [minHeight]="'525px'"

            [imageUrls]="imageUrlArrayLabs"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;" data-toggle="modal" data-target="#orderImagesModalLabs">OK</button>

      </div>
    </div>
  </div>
</div>
